import { computed } from 'vue'

export default {
    name: 'MaterialCard',
    props: {
        data: {
            type: Object,
            required: true,
            default: {
                imageUrl: 'https://picsum.photos/500/700',
                title: 'Grundbog i små børns sorg Grundbog i små børns sorg Grundbog i små børns sorg Grundbog i små børns sorg',
                displayPrice: '139,-',
                url: 'https://www.dr.dk'
            }
        }
    },
    setup(props) {
        var desktopImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:430,height:608')
        var mobileImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:215,height:304')

        return {
            desktopImageUrl,
            mobileImageUrl
        }
    }
}
